import { Link } from "react-router-dom";

export default function IntakesSection({ section, items = [] }) {
  if (!section || section.is_enabled === 0) return null;

  return (
    <section className="section section--alt intake-section" aria-label="Yearly intakes">
      <div className="section__inner">
        <div className="section__header">
          {section.badge && <span className="section__tag">{section.badge}</span>}
          <h2 className="section__title">{section.title}</h2>
          {section.subtitle && <p className="section__subtitle">{section.subtitle}</p>}
        </div>

        <div className="intake-section__grid">
          {items.map((item) => (
            <article key={item.id} className="intake-card">
              <div className="intake-card__month">{item.extra?.month || item.title}</div>
              <h3>{item.title}</h3>
              {item.subtitle && <p className="intake-card__subtitle">{item.subtitle}</p>}
              {item.body && <p className="intake-card__body">{item.body}</p>}
            </article>
          ))}
        </div>

        {section.button_text && section.button_link && (
          <div className="intake-section__actions">
            <Link to={section.button_link} className="btn btn--accent btn--lg">
              {section.button_text}
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
